<template>
  <div>
    <AdCard
      :button_text="button_text"
      :banner="banner"
      :company_logo="company_logo"
      :company_name="company_name"
      :footer_tag="footer_tag"
      :role_icon="role_icon"
      :role_title="role_title"
      :website_link="website_link"
      :website_name="website_name"
    >
      <template v-slot:content>
        <p>
          <b>Antibacterial Liquid Chalk</b> Available NOW! Back to gym
          <b>essential</b>!
        </p>
        <ul>
          <li>Improves Grip!</li>
          <li>Eliminates Sweat!</li>
          <li>Antibacterial Properties!</li>
        </ul>
        <p>
          <b>FREE</b> Delivery on all UK Orders!
        </p>
      </template>
    </AdCard>
  </div>
</template>

<script>
import AdCard from "@/components/molecules/AdCard.vue";
export default {
  components: {
    AdCard
  },
  data() {
    return {
      banner: require('@/assets/advertisements/quickgrip/quick_grip_banner.jpg'),
      button_text: "Learn more",
      company_logo: require('@/assets/advertisements/quickgrip/logo_small.jpg'),
      company_name: "Quick Grip",
      footer_tag: "Work out safely.",
      role_icon: "fas fa-user-friends",
      role_title: "Associated Partner",
      website_link: "https://www.quickgrip.co.uk",
      website_name: "quickgrip.co.uk"
    };
  }
};
</script>


<style lang="scss" scoped>
  ul {
    list-style: none;
    margin: 0.25rem;
  }

  ul li:before {
    content: "✓";
    padding-right: 0.25rem;
    color: #00c5fd;
  }

</style>